import { getFont, useTheme } from '@24i/nxg-sdk-higgs';
import React from 'react';
import styled from 'styled-components';
export const Container = ({ children, fontName = 'body2' }) => {
    const { theme } = useTheme();
    const Div = styled.div `
        font-family: ${getFont(theme, fontName).fontFamily};
        font-weight: ${getFont(theme, fontName).fontWeight};
        text-align: center;
        color: ${theme.color.textSecondary};
        margin-top: 42px;
    `;
    return React.createElement(Div, null, children);
};
//# sourceMappingURL=index.js.map